import { Vertical } from "@/components/standard/BFLayout"
import { Pressable } from "react-native"
import { Body, H2, H5 } from "@/components/standard/BFText"
import { router } from "expo-router"
import * as React from "react"
import { useCallback, useEffect, useRef } from "react"
import {
  BottomSheetBackdrop,
  type BottomSheetBackdropProps,
  BottomSheetModal,
  BottomSheetView,
} from "@gorhom/bottom-sheet"
import { BFColors } from "@/constants/Colors"
import { PrimaryButton } from "@/components/buttons/CommonButtons"
import { useSafeAreaInsets } from "react-native-safe-area-context"

export const SwitchPropertyPopup = ({
  visible,
  onClose,
}: {
  visible: boolean
  onClose: (moveOn: boolean) => void
}) => {
  const bottomSheetModalRef = useRef<BottomSheetModal>(null)
  const insets = useSafeAreaInsets()

  const renderBackdrop = useCallback(
    (props: BottomSheetBackdropProps) => (
      <BottomSheetBackdrop
        {...props}
        appearsOnIndex={0}
        disappearsOnIndex={-1}
        onPress={() => {
          onClose(false)
        }}
      />
    ),
    []
  )

  useEffect(() => {
    if (!visible) {
      bottomSheetModalRef.current?.dismiss()
      onClose(false)
    } else {
      bottomSheetModalRef.current?.present()
    }
  }, [visible])

  return (
    <BottomSheetModal
      ref={bottomSheetModalRef}
      backdropComponent={renderBackdrop}
      backgroundStyle={{ backgroundColor: "#FFFFFF" }}
      handleIndicatorStyle={{ backgroundColor: BFColors.offWhite }}
      enableDynamicSizing={true}
    >
      <BottomSheetView
        className={"flex-1 px-6"}
        style={{ paddingBottom: insets.bottom }}
      >
        <Vertical className={"justify-between flex-1"}>
          <Vertical className={"gap-2 mt-10"}>
            <Vertical className={"gap-2"}>
              <H2 className={"text-center"} color={"primary"}>
                Switching properties?
              </H2>
              <Body className={"text-center"} color={"primary"}>
                To use a new address, start a new quote. Your current progress
                is saved in your Loan Dashboard.
              </Body>
            </Vertical>

            <Vertical className={"my-5 gap-5"}>
              <PrimaryButton
                title={"Start New Quote"}
                testID={"start-new-quote"}
                onPress={() => {
                  bottomSheetModalRef.current?.dismiss()
                  onClose(true)
                  router.push("/loans/setup")
                }}
              />

              <Pressable
                testID={"continue-this-quote"}
                onPress={() => {
                  bottomSheetModalRef.current?.dismiss()
                  onClose(false)
                }}
              >
                <H5 className={"underline text-center"} color={"primaryLight"}>
                  Continue This Quote
                </H5>
              </Pressable>
            </Vertical>
          </Vertical>
        </Vertical>
      </BottomSheetView>
    </BottomSheetModal>
  )
}
